<template>
  <div ref="watermarkContainer" class="watermark-container"/>
</template>

<script>
export default {
  name: 'WatermarkIndex',
  props: {
    content: {
      type: String,
      default: '内部资料,禁止拍照'
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 200
    },
    rotate: {
      type: Number,
      default: 30
    },
    fontSize: {
      type: Number,
      default: 13
    },
    fontColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.1)'
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      watermarkId: 'watermark-' + Date.now()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.createWatermark();
      window.addEventListener('resize', this.handleResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    const watermark = document.getElementById(this.watermarkId);
    if (watermark) {
      watermark.remove();
    }
  },
  methods: {
    createWatermark() {
      if (!this.$refs.watermarkContainer) return;

      // 移除旧水印
      const oldWatermark = document.getElementById(this.watermarkId);
      if (oldWatermark) {
        oldWatermark.remove();
      }

      // 创建 canvas
      const canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.font = `${this.fontSize}px`;
      ctx.fillStyle = this.fontColor;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.rotate((this.rotate * Math.PI) / 180);
      ctx.fillText(this.content, canvas.width / 2, canvas.height / 2);

      const base64Url = canvas.toDataURL();

      // 创建水印覆盖层
      const watermarkDiv = document.createElement('div');
      watermarkDiv.id = this.watermarkId;
      watermarkDiv.style.pointerEvents = 'none';
      watermarkDiv.style.position = 'fixed';
      watermarkDiv.style.top = '0';
      watermarkDiv.style.left = '0';
      watermarkDiv.style.width = '100%';
      watermarkDiv.style.height = '100%';
      watermarkDiv.style.zIndex = this.zIndex;
      watermarkDiv.style.backgroundImage = `url("${base64Url}")`;

      this.$refs.watermarkContainer.appendChild(watermarkDiv);
    },
    handleResize() {
      this.createWatermark();
    }
  }
}
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
}
</style>
